import loadable from "@loadable/component";

import type { PageBlockRegistry } from "../../core/page-blocks/Block.component";
import { localBlockComponents, localMicrositeComponents } from "../local/registry-block";

const CLAYBUCK_GUESTS_HINT = "display-hints/clay-buck-guests";
const CLAYBUCK_TOP_STORY_HINT = "display-hints/clay-buck-main";

const ClayBuckGuests = loadable(() => import("./components/feed/ClayBuckGuests.component"));
const ClayBuckTopStory = loadable(() => import("./components/feed/ClayBuckTopStory.component"));

export const clayBuckBlockComponents: PageBlockRegistry = {
  ...localBlockComponents,
  feed: block => {
    if (block?.tags?.includes(CLAYBUCK_GUESTS_HINT)) {
      return ClayBuckGuests;
    }
    if (block?.tags?.includes(CLAYBUCK_TOP_STORY_HINT)) {
      return ClayBuckTopStory;
    }
    return localBlockComponents.feed(block);
  },
};

export const clayBuckMicrositeComponents: PageBlockRegistry = {
  ...localMicrositeComponents,
};
